export const replaceNewLineWithParagraph = (input: string): string =>
  input
    .replace(/(.*?)\n/g, '<p>$1</p>')
    .replace(/([^>]+?)$/g, '<p>$1</p>');
